import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { ChartEnums } from "models/enums";
//#endregion
//#region components
import { ChartContainer } from "components/common";
//#endregion
import { DateHelper, UtilsHelper, QueryStateHelper, LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import { FormFieldConstants } from "utils/constants";
import { useLocation, useNavigate } from "react-router-dom";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;
import { TranslationKeys } from "translations";
import { AccountingCategoryType } from "../../../models/enums/accounting";

const OperatingProfitAccumulatedLineChart: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const bookingDateEncoder = QueryStateHelper.dateRangeQueryEncoder(
    FormFieldConstants.Accounting.CompanyBooksReportFilter.BookingDate
  );
  const categoryIdEncoder = QueryStateHelper.numberQueryEncoder(
    FormFieldConstants.Accounting.CompanyBooksReportFilter.CategoryId
  );
  const categoryEncoder = QueryStateHelper.stringQueryEncoder(
    FormFieldConstants.Accounting.CompanyBooksReportFilter.Category
  );

  const generateLabels = (chartData?: WintSuperkollAPIModel.ReportWidget): string[] => {
    let labels = [""];
    if (chartData?.data) {
      labels = DateHelper.getMonthsBetween(chartData.data[0].startDate, chartData.data[0].endDate).map((month) =>
        UtilsHelper.capitalizeFirst(month.substring(0, 3))
      );
    }
    return labels;
  };

  const operatingProfitCategoryId = AccountingCategoryType.SumOperatingIncome;

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Line}
      chartAPIKey={GraphConstants.ChartKeys.AccumulatedOperatingProfit}
      chartCacheKey={GraphConstants.ChartKeys.AccumulatedOperatingProfit}
      chartTitle={""}
      customLabelsHandler={generateLabels}
      yAxisTickUnit={ChartEnums.YAxisTickUnitType.Currency}
      useClickableChart
      onPeriodClick={({ start, end }) => {
        if (!start || !end) return;
        const start12 = DateHelper.getFirstDayOfMonth(DateHelper.addMonths(new Date(start), -12));
        const params = new URLSearchParams("");
        bookingDateEncoder.urlEncode(params, undefined, { start: start12, end });
        categoryIdEncoder.urlEncode(params, undefined, operatingProfitCategoryId);
        categoryEncoder.urlEncode(
          params,
          undefined,
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.OperatingProfit)
        );
        navigate(`${UrlHelper.formatPath(`/Reports/Accounting`)}?${params.toString()}`, {
          state: { background: location },
        });
      }}
      overrideLabelFontSize={10}
    />
  );
};

export default OperatingProfitAccumulatedLineChart;
